import { UntypedFormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

export const URL_PROTOCOL_PATTERN = /^([a-zA-Z0-9]*?):\/\//;
export const SOFT_URL_PATTERN = /^([a-zA-Z0-9]*?):\/\/.+/;
export const trimUrl = (value: string): string | null =>
  value ? value.replace(/(^\s+)|(\s+$)/g, '') : null;

export function softUrlValidator(control: UntypedFormControl): { softUrl: boolean } | null {
  const trimmed = trimUrl(control.value);
  return isEmpty(trimmed) || SOFT_URL_PATTERN.test(trimmed) ? null : { softUrl: true };
}
